import { Dropdown, Form, Modal, Popconfirm, Tooltip } from "antd";
import React, {useState, useMemo} from "react";
import dayjs from "dayjs";
import {
    addUnderScoreWithUpper,
    addUnderScoreWithUpperCase,
    dateFormat,
    removeUnderScoreWithLowerCase
} from "../../utility/utility";
import "./../../styles/component/setting.scss"
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import toastify from "../../common/toastify";
import Grid from "../../common/table";
import { CircleCheck, CircleX, Ellipsis, Pencil, Trash } from "lucide-react";
import LoadingSkeleton from "../../page-components/common/loading-skeleton/loading-skeleton";

function CommonTableComponent({propsData}: any) {
    const [form] = Form.useForm();
    const [isEditMode, setIsEditMode] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [editingId, setEditingId] = useState(null);
    const [status, setStatus] = useState<boolean>(true);
    const {
        fetchData, setAllData, formFields, columns, title, create, getAll, deleteById, isModalOpen, setIsModalOpen, showStatus = false,
        totalHoliday, setTotalHoliday, formFieldsType, tableFieldsType, updateRecord = false, ...restParams
    } = propsData;
    const memoizedFilterValues = useMemo(() => propsData.filterValues, [JSON.stringify(propsData.filterValues)]);

    const {value: allNewData, setValue: setAllNewData, deleteHandle, refetch, loading} = useFetchTableData(
        {
            getAll,
            tableColumns: columns.map((c: any) => c.dataIndex),
            deleteById,
        },
        memoizedFilterValues
    );

    const updatedColumns = [
        ...columns,
        {
            title: 'Action',
            align: "left",
            width: "10%",
            render: (_: any, record: any) => {

                const menuItems = [
                    ...(showStatus && title !== "Leave Application"
                        ? [
                            {
                                key: "status",
                                label: record.status ? "Deactivate" : "Activate",
                                icon: record.status ? (
                                    <CircleX className="action-close" />
                                ) : (
                                    <CircleCheck className="action-approve" />
                                ),
                                onClick: () =>
                                    Modal.confirm({
                                        title: `Are you sure to ${
                                            record.status ? "deactivate" : "activate"
                                        }?`,
                                        onOk: () => updateStatus(record),
                                    }),
                            },
                        ]
                        : []),

                    ...(title !== "Leave Application"
                        ? [
                            {
                                key: "delete",
                                label: "Delete",
                                icon: <Trash className="action-delete" />,
                                onClick: () =>
                                    Modal.confirm({
                                        title: "Are you sure to delete?",
                                        okButtonProps: { danger: true },
                                        onOk: () => deleteHandle(record),
                                    }),
                            },
                        ]
                        : []),

                    ...(updateRecord
                        ? [
                            {
                                key: "update",
                                label: "Update",
                                icon: <Pencil className="action-edit" />,
                                onClick: () => handleUpdate(record),
                            },
                        ]
                        : []),
                ];
                return(
                    <Dropdown menu={{items: menuItems}} overlayClassName={'pn-table-action-menu'}>
                        <Ellipsis className={'pn-table-actions-icon'}/>
                    </Dropdown>
                )
            }
        },
    ]

    const getDayOfWeek = (date: any) => {
        const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        const dayIndex = new Date(date).getDay();
        return daysOfWeek[dayIndex];
    };

    const holidayHandle = (values: any) => {
        let payload: any = {
            "year": new Date().getFullYear(),
            "name": values.name,
            "type": values.type,
            "calender": {}
        }

        const tempCalender = values.date.map((item: any) => {
            let tempCal: any = {};
            tempCal["date"] = dayjs(item).format("YYYY-MM-DD");
            tempCal["day"] = getDayOfWeek(item).toUpperCase();
            return {...tempCal};
        });
        payload.calender = tempCalender;
        return payload;
    }

    const formFieldsFormat = (values: any) => {
        let payloadFormat = {...values};
        const keys: any = Object.keys(payloadFormat);

        keys.forEach((key: any) => {
            if (key === 'displayName') {
                return;
            }
            let type = formFieldsType.find((item: any) => item.name === key);
            switch (type.type) {
                case "payloadCode":
                    payloadFormat[key] = addUnderScoreWithUpperCase(payloadFormat[key]);
                    break;
                case "code":
                    payloadFormat[key] = addUnderScoreWithUpper(payloadFormat[key]);
                    break;
                case "date":
                    payloadFormat[key] = dayjs(payloadFormat[key]).format("YYYY-MM-DD");
                    break;
                case "number":
                    break;
                case 1:
                    payloadFormat[key] = dateFormat(payloadFormat[key]);
                    break;
                default:
                    payloadFormat[key] = removeUnderScoreWithLowerCase(payloadFormat[key]);
            }
        });
        return payloadFormat;
    }

    const handleUpdate = async (record: any) => {
        setIsModalOpen(true);
        form.setFieldsValue({
            ...record,
            startDate: dayjs(record.startDate),
            endDate: dayjs(record.endDate),
            active: record.active === "Active" || record.active === true
        });
        setIsEditMode(true);
        setEditingId(record.id?.toString());
        let status = false;
        if (record.active === "Active" || record.active === true) {
            status = true;
        }
        setStatus(status);
    }

    const tableFieldFormat = (values: any) => {
        let payloadFormat = {...values};
        if (payloadFormat.displayName) {
            return payloadFormat;
        }
        tableFieldsType.forEach((key: any) => {
            switch (key.type) {
                case "code":
                    payloadFormat[key.name] = addUnderScoreWithUpper(payloadFormat[key.name]);
                    break;
                case "payloadCode":
                    payloadFormat[key.name] = addUnderScoreWithUpperCase(payloadFormat[key.name]);
                    break;
                case "date":
                    payloadFormat[key.name] = dateFormat(payloadFormat[key.name]);
                    break;
                case "string":
                    payloadFormat[key.name] = removeUnderScoreWithLowerCase(payloadFormat[key.name]);
                    break;
                case "number":
                    payloadFormat[key.name] = removeUnderScoreWithLowerCase(payloadFormat[key.name]);
                    break;
                case "null":
                    payloadFormat[key.name] = key.value.find((item: any) => item.id === form.getFieldValue(key.field)).name;
                    break;
                default:
                    payloadFormat[key.name] = key.value;
            }
        });
        return payloadFormat;
    }

    const handleFormSubmit = async () => {
        let values = form.getFieldsValue();
        let payloadFormat: any = {...values};
        if (title === "Holiday") payloadFormat = holidayHandle(payloadFormat);
        else payloadFormat = formFieldsFormat(payloadFormat);
        try {
            if (isEditMode && title === 'Designation') {
                const updatePayload = {...payloadFormat, id: editingId, active: status};
                await restParams.updateDesignation(updatePayload, editingId);
                const updatedRow = tableFieldFormat({...updatePayload});
                setAllNewData((prev: any) => prev.map((item: any) => (item.id === editingId ? {
                    ...item, ...updatedRow,
                    status: status
                } : item)));
                toastify({title: "Success", message: "Successfully updated designation!", isSuccessful: true});
            } else if (isEditMode && title === 'Qualification') {
                const updatePayload = {...payloadFormat, id: editingId, active: status};
                await restParams.updateQualification(updatePayload, editingId);
                const updatedRow = tableFieldFormat({...updatePayload});
                setAllNewData((prev: any) =>
                    prev.map((item: any) => (item.id === editingId ? {...item, ...updatedRow, status: status} : item))
                );
                toastify({title: "Success", message: "Successfully updated qualification!", isSuccessful: true});
            } else if (isEditMode && title === "Leave Period") {
                const updatePayload = {
                    ...payloadFormat,
                    id: editingId,
                    active: values.active,
                    startDate: dayjs(payloadFormat.startDate).format("YYYY-MM-DD"),
                    endDate: dayjs(payloadFormat.endDate).format("YYYY-MM-DD")
                };
                console.log("updatePayload: ", updatePayload)
                await restParams.updateLeavePeriodById(editingId, updatePayload);

                const updatedRow = tableFieldFormat({...updatePayload});

                setAllNewData((prev: any) =>
                    prev.map((item: any) =>
                        item.id === editingId
                            ? {...item, ...updatedRow, status: values.active}
                            : item
                    )
                );
                toastify({title: "Success", message: "Successfully updated Leave Period!", isSuccessful: true});
            } else {
                await create(payloadFormat);
                console.log("payloadFormat", payloadFormat);
                // calls api to refetch the data
                await refetch();
                {
                    if (title === "Qualification") {
                        toastify({
                            title: "Success",
                            message: `Successfully added ${values.displayName} as a new Qualification!`,
                            isSuccessful: true
                        })
                    }
                    if (title === "Designation") {
                        toastify({
                            title: "Success",
                            message: `Successfully added  ${values.displayName} as a new Designation!`,
                            isSuccessful: true
                        })
                    }
                    if (title === "Leave Type") {
                        toastify({
                            title: "Success",
                            message: `Successfully added ${values.type} as a new Leave Type!`,
                            isSuccessful: true
                        })
                    }
                    if (title === "Work Week") {
                        toastify({
                            title: "Success",
                            message: `Successfully added ${values.day} as a new Work Week!`,
                            isSuccessful: true
                        })
                    }
                    if (title === "Leave Period") {
                        toastify({
                            title: "Success",
                            message: `Successfully added new Leave Period!`,
                            isSuccessful: true
                        })
                    }
                }
            }
            setIsModalOpen(false);
            form.resetFields();
            setIsEditMode(false);
            setEditingId(null);
            setButtonDisabled(true);
        } catch (e) {
            console.log(e)
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
        setIsEditMode(false);
        setButtonDisabled(true);
        setEditingId(null);
    };

    const updateStatus = async (record: any) => {
        try {
            await restParams.update(record.id, !record.status);
            setAllNewData((prev: any) => prev.map((item: any) => {
                    if (item.id === record.id) {
                        if (record.active === "Active") {
                            item.active = "Inactive"
                            item.status = false
                        } else {
                            item.active = "Active"
                            item.status = true
                        }
                    }
                    return item;
                }
            ))
        } catch (e) {
            console.log(e)
        }
    }

    const handleFormFieldsChange = () => {
        isEditMode ? setButtonDisabled(false) :
            setButtonDisabled(!form.isFieldsTouched(true) || !!form.getFieldsError().filter(({errors}) => errors.length).length)
    }

    return (
        <div>
            <Modal
                title={isEditMode ? `Edit ${title}` : `Add ${title}`}
                open={isModalOpen}
                onCancel={handleCancel}
                onOk={handleFormSubmit}
                okButtonProps={{disabled: buttonDisabled}}
                className={"hrms-app settings-modal"}
            >
                <Form
                    form={form}
                    className={"setting-form"}
                    layout="horizontal"
                    onFieldsChange={handleFormFieldsChange}
                >
                    {formFields?.map((formInput: any, index: number) => (
                        <React.Fragment key={index}>{formInput}</React.Fragment>))}
                </Form>
            </Modal>
            <div className={'settings-table'}>
                <LoadingSkeleton loading={loading}>
                    <Grid
                        bordered
                        columns={updatedColumns}
                        dataSource={allNewData}
                        pagination={true}
                    />
                </LoadingSkeleton>

            </div>

        </div>)
}

export default CommonTableComponent;
